<style lang="less" scoped>
  .abs-center { position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); }
  .abs-tcenter { position: absolute; top: 50%; transform: translate(0,-50%); }
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }

  .content {
    padding: 29px 40px;
  }
</style>

<template lang="pug">
  section.content
    .title-content
      h2 이력조회 #[span (최근 3개월)]

    div(v-loading="loading")
      el-table(v-if="!loading", :data="tableData", border, align="center", width="100%" class="table-type-1")
        el-table-column(type="index", width="80", label="번호", align="center", :index="indexMethod")
        el-table-column(prop="createDate", width="200", label="일자", align="center")
          p(slot-scope="scope") {{ scope.row.createDate | displayDate }}
        el-table-column(prop="createDate", width="200", label="시간", align="center")
          p(slot-scope="scope") {{ scope.row.createDate | displayTime }}
        el-table-column(prop="activityType", width="200", label="구분", align="center")
          p(slot-scope="scope") {{ scope.row.activityType | displayActivityType }}
        el-table-column(prop="description", label="내용", align="center")
        el-table-column(prop="creatorIp", width="200", label="접속 IP", align="center")
      .pager
        el-pagination(
          v-if="!loading",
          background,
          layout="prev, pager, next",
          @current-change="paging",
          :page-size="ps",
          :total="rows",
        )
</template>

<script>
import moment from 'moment';

moment.locale('ko');
export default {
  async mounted() {
    this.paging(1);
  },
  filters: {
    displayDate(value) {
      return moment(value).format('YYYY.MM.DD');
    },
    displayTime(value) {
      return moment(value).format('HH:mm:ss');
    },
    displayActivityType(value) {
      let result = '';
      if (value === 'L') {
        result = '접속';
      } else if (value === 'A') {
        result = '광고관련';
      } else if (value === 'B') {
        result = '비즈머니관련';
      } else if (value === 'P') {
        result = '보너스관련';
      }
      return result;
    },
  },
  methods: {
    handleView(index, row) {
      console.log(index, row);
    },
    async paging(value) {
      this.pg = value;
      this.loading = true;
      const list = await this.$http.get('/api/mkc/v1/store-activity', {
        params: {
          ps: this.ps,
          pg: this.pg,
        },
      });

      this.rows = list.data.total;
      this.tableData = list.data.list;
      this.loading = false;

      window.scrollTo(0, 0);
    },

    indexMethod(index) {
      return (this.rows - (this.pg - 1) * this.ps) - index;
    },
  },
  data() {
    return {
      rows: 0,
      pg: 1,
      ps: 10,

      form: {
        device: '',
        devices: [{
          value: '',
          label: '전체',
        }, {
          value: 'mobile',
          label: '모바일',
        }, {
          value: 'pc',
          label: 'PC',
        }],

        daynmonth: 'day',
        daynmonths: [{
          value: 'day',
          label: '일별',
        }, {
          value: 'month',
          label: '월별',
        }],

        // 기간 이전달 부터
        defaultDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),

        // 기간 기본값
        dateLimit: [moment().subtract(1, 'month').format('YYYY-MM-DD'), moment()],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },

      // 테이블 데이터
      tableData: [],
      loading: false,
    };
  },
};
</script>
